import { render, staticRenderFns } from "./FPTableRecurringSharedDetails.vue?vue&type=template&id=5e634bd4"
import script from "./FPTableRecurringSharedDetails.vue?vue&type=script&lang=js"
export * from "./FPTableRecurringSharedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports